import React, { useContext, useState } from 'react';
import { Box, Button, Card, CardContent, CardHeader, Stack, Typography } from '@mui/material';
import { translate as t } from 'hooks/useTranslations';
import { ChevronRight, ExpandLess, ExpandMore, Refresh } from '@mui/icons-material';
import { AppContext } from 'views/App/context';
import useManualMetrics from '../_data_sources/useManualMetrics';
import Loading from 'views/App/Portal/Loading';
import ManualItem from './ManualItem';
import { neutral } from '_lex/_foundations/phxColors';

export default function ManualMetrics() {
  const { currentOrganizationId } = useContext(AppContext);
  const [showAll, setShowAll] = useState(false);
  const metricsQuery = useManualMetrics(currentOrganizationId);

  if (metricsQuery.isLoading) return <Loading />;

  if (metricsQuery.isError) {
    return (
      <Card className='manual-metrics lex-dashboard-card'>
        <CardHeader
          title={t('dashboard.policy.manualMetrics.title')}
          action={
            <Button
              color='secondary'
              size='small'
              href='/admin/policy/draft-manuals'
              endIcon={<ChevronRight />}
            >
              {t('dashboard.policy.manualMetrics.viewAll')}
            </Button>
          }
        />
        <CardContent>
          <Box sx={{ textAlign: 'center', py: 4 }}>
            <Typography
              color='error'
              sx={{ mb: 2 }}
            >
              {t('dashboard.policy.manualMetrics.error')}
            </Typography>
            <Button
              variant='contained'
              startIcon={<Refresh />}
              onClick={() => metricsQuery.refetch()}
            >
              {t('dashboard.policy.manualMetrics.retry')}
            </Button>
          </Box>
        </CardContent>
      </Card>
    );
  }

  const sortedMetrics = metricsQuery.data
    ? [...metricsQuery.data].sort((a, b) => b.policyUpdates.length - a.policyUpdates.length)
    : [];

  return sortedMetrics.length > 0 ? (
    <Card className='manual-metrics lex-dashboard-card'>
      <CardHeader title={t('dashboard.policy.manualMetrics.title')} />
      <CardContent>
        {sortedMetrics.length === 0 ? (
          <Box>Empty</Box>
        ) : (
          <Stack spacing={8}>
            <Card>
              <CardContent>
                {sortedMetrics.slice(0, showAll ? sortedMetrics.length : 2).map((metric) => (
                  <Box
                    key={metric.id}
                    sx={{ mb: 4, pb: 4, borderBottom: `solid 1px ${neutral[200]}` }}
                  >
                    <ManualItem
                      key={metric.id}
                      metric={metric}
                    />
                  </Box>
                ))}
                {sortedMetrics.length > 2 && (
                  <Box sx={{ mt: 4, display: 'flex', justifyContent: 'center' }}>
                    {showAll ? (
                      <Button
                        className='xs'
                        variant='text'
                        size='small'
                        onClick={() => setShowAll(false)}
                      >
                        {t('dashboard.policy.manualMetrics.showLess')} <ExpandLess />
                      </Button>
                    ) : (
                      <Button
                        className='xs'
                        variant='text'
                        size='small'
                        onClick={() => setShowAll(true)}
                      >
                        {t('dashboard.policy.manualMetrics.showMore', '', {
                          count: (sortedMetrics.length - 2).toString(),
                        })}{' '}
                        <ExpandMore />
                      </Button>
                    )}
                  </Box>
                )}
              </CardContent>
            </Card>
          </Stack>
        )}
      </CardContent>
    </Card>
  ) : null;
}
